import { render, staticRenderFns } from "./helpActivityModal.vue?vue&type=template&id=70e607f3&scoped=true"
import script from "./helpActivityModal.vue?vue&type=script&lang=js"
export * from "./helpActivityModal.vue?vue&type=script&lang=js"
import style0 from "./helpActivityModal.vue?vue&type=style&index=0&id=70e607f3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e607f3",
  null
  
)

export default component.exports